import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { useQueryClient } from "@tanstack/react-query"
import { useAuthStore } from "@/stores/auth"
import { LOGIN } from "@/constants/paths/shared"

export function useSignOut() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const logout = useAuthStore((state) => state.logout)

  return useCallback(() => {
    logout()
    queryClient.clear()
    navigate(LOGIN, { replace: true })
  }, [logout, navigate, queryClient])
}
